import ApiService from '@/services/ApiService'
import { useUserStore } from '@/stores/UserStore'
import { User } from '@/models/User'
import ListRequest from '@/models/requests/ListRequest'
import { PaginationModel } from '@/models/PaginationModel'

export default class UserService {
  public static async create(user: Partial<User>): Promise<User> {
    return ApiService.post<User>(`users`, user)
  }

  public static async delete(id: string): Promise<void> {
    return ApiService.delete<void>(`users/${id}`)
  }

  public static async get(id: string): Promise<User> {
    return ApiService.get<User>(`users/${id}`)
  }

  public static async list(queryParams: ListRequest): Promise<PaginationModel<User>> {
    return ApiService.get<PaginationModel<User>>(`users`, queryParams)
  }

  public static async listAll(): Promise<User[]> {
    return ApiService.get<User[]>(`users/all`)
  }

  public static async loadInfo(): Promise<void> {
    return ApiService.get<{ token: string, user: User }>(`users/info`).then((response) => {
      const userStore = useUserStore()
      userStore.user = response.user
    })
  }

  public static async login(email: string): Promise<void> {
    return ApiService.post(`auth/login`, { email })
  }

  public static async logout(): Promise<void> {
    return ApiService.post<void>(`auth/logout`).finally(() => {
      const userStore = useUserStore()
      userStore.logout()
    })
  }

  public static async otpLogin(email: string, otp: string): Promise<void> {
    return ApiService.post<{ token: string, user: User }>(`auth/otp-login`, { email, otp }).then((response) => {
      const userStore = useUserStore()
      userStore.logout()
      userStore.token = response.token
      userStore.user = response.user
      return this.loadInfo()
    })
  }

  public static async apply(postData: {
    email?: string, first_name: string, last_name: string, lang: string,
    phone?: string, date_of_birth?: string | null, nationality?: string, place_of_residence?: string,
    altcha: string,
  }): Promise<void> {
    return ApiService.post('auth/apply', postData)
  }

  public static async upcomingBirthdays(): Promise<{ id: string; first_name: string; last_name: string; date_of_birth: string; age: number }[]> {
    return ApiService.get('dashboard/upcoming-birthdays')
  }

  public static async sendWelcomeMail(userId: string): Promise<void> {
    return ApiService.post<void>(`users/${userId}/send-welcome-mail`)
  }

  public static async update(user: Partial<User>): Promise<User> {
    return ApiService.put<User>(`users/${user.id}`, user).then((updatedUser) => {
      const userStore = useUserStore()
      if (userStore.user && updatedUser.id === userStore.user.id) {
        userStore.user = updatedUser
      }
      return updatedUser
    })
  }
}
